export const WIDGET_REGISTRY = {
  client_breakdown: {
    label: "Client Breakdown",
    icon: "🥧",
    description: "Pie chart of companies vs individuals",
    defaultW: 4, defaultH: 7, minW: 3, minH: 5,
  },
  client_stats: {
    label: "Client Stats",
    icon: "📊",
    description: "Summary counts: total, companies, individuals, directors",
    defaultW: 8, defaultH: 4, minW: 4, minH: 3,
  },
  upcoming_jobs: {
    label: "Upcoming Jobs",
    icon: "📋",
    description: "Jobs due in the next 3 months",
    defaultW: 12, defaultH: 9, minW: 6, minH: 5,
  },
  all_jobs: {
    label: "All Jobs",
    icon: "🗂️",
    description: "All jobs across all clients with status filters and search",
    defaultW: 12, defaultH: 11, minW: 12, minH: 7,
  },
  quick_actions: {
    label: "Quick Actions",
    icon: "⚡",
    description: "Shortcut buttons to common actions",
    defaultW: 4, defaultH: 4, minW: 3, minH: 3,
  },
  recent_clients: {
    label: "Recent Clients",
    icon: "👥",
    description: "Recently added client profiles",
    defaultW: 6, defaultH: 6, minW: 4, minH: 4,
  },
  // New widgets for improved dashboard
  bank_balances: {
    label: "Bank Balances",
    icon: "🏦",
    description: "Live balances across linked bank accounts",
    defaultW: 6, defaultH: 4, minW: 4, minH: 3,
  },
  aged_receivables: {
    label: "Aged Receivables",
    icon: "📅",
    description: "Outstanding invoices by age buckets",
    defaultW: 6, defaultH: 6, minW: 4, minH: 4,
  },
  vat_deadlines: {
    label: "VAT & Tax Deadlines",
    icon: "🧾",
    description: "Upcoming VAT and tax submission deadlines",
    defaultW: 6, defaultH: 3, minW: 4, minH: 3,
  },
  cashflow_forecast: {
    label: "Cashflow Forecast",
    icon: "📈",
    description: "30/90 day cashflow outlook",
    defaultW: 8, defaultH: 5, minW: 6, minH: 4,
  },
  client_health: {
    label: "Client Health",
    icon: "❤️",
    description: "Risk score per client (missing docs, overdue items)",
    defaultW: 6, defaultH: 5, minW: 4, minH: 4,
  },
  revenue_trend: {
    label: "Revenue Trend",
    icon: "💹",
    description: "MTD / YTD revenue trend by service",
    defaultW: 8, defaultH: 4, minW: 6, minH: 3,
  },
  system_health: {
    label: "System Health & Alerts",
    icon: "🔔",
    description: "API reachability, recent errors and alerts",
    defaultW: 12, defaultH: 2, minW: 6, minH: 2,
  },
};

// Default starter widgets for a useful dashboard
export const DEFAULT_WIDGETS = [
  { id: "w-system_health-default", type: "system_health" },
  { id: "w-bank_balances-default", type: "bank_balances" },
  { id: "w-aged_receivables-default", type: "aged_receivables" },
  { id: "w-cashflow_forecast-default", type: "cashflow_forecast" },
  { id: "w-revenue_trend-default", type: "revenue_trend" },
  { id: "w-upcoming_jobs-default", type: "upcoming_jobs" },
  { id: "w-client_health-default", type: "client_health" },
];

// A conservative default layout (lg breakpoint)
export const DEFAULT_LAYOUT = [
  { i: "w-system_health-default", x: 0, y: 0, w: 12, h: 2 },
  { i: "w-bank_balances-default", x: 0, y: 2, w: 6, h: 4 },
  { i: "w-aged_receivables-default", x: 6, y: 2, w: 6, h: 6 },
  { i: "w-cashflow_forecast-default", x: 0, y: 6, w: 8, h: 5 },
  { i: "w-revenue_trend-default", x: 8, y: 6, w: 4, h: 4 },
  { i: "w-upcoming_jobs-default", x: 0, y: 11, w: 12, h: 9 },
  { i: "w-client_health-default", x: 0, y: 20, w: 6, h: 5 },
];


